/**
 * Acomodo de las señales de un nodo del dibujo de la red (etapa 1b, 2026-10-02): en un renglón, y lo que no quepa en el ancho del
 * nodo se resume en «+N» (su texto completo va en el título del nodo). Ninguna señal se sale del recuadro.
 * Etapa 4, ajustes 4d: se movió aquí desde app/nexo-frontend/src/ui/chips.ts (que ahora sólo reexporta); lo usa también Argus Team.
 */

/** Ancho que ocupa una señal de `texto` caracteres, a 8.5 px en negrita (el mismo cálculo con el que se dibuja). */
export const anchoChip = (texto: string): number => texto.length * 5.4 + 10;

/** Posición x de cada señal que cabe, y cuántas quedaron fuera (se dibujan como «+N» al final). */
export function colocarChips(textos: readonly string[], ancho: number, margen = 12, separacion = 4): { x: number[]; fuera: number } {
  const limite = ancho - 6;
  const x: number[] = [];
  let cx = margen;
  for (let i = 0; i < textos.length; i++) {
    const resto = textos.length - i - 1;
    const cw = anchoChip(textos[i]!);
    // Si después de ésta quedan otras, debe caber también el «+N».
    const reserva = resto > 0 ? separacion + anchoChip(`+${resto}`) : 0;
    if (cx + cw > limite || (resto > 0 && cx + cw + reserva > limite && !cabenTodas(textos.slice(i), cx, limite, separacion))) {
      return { x, fuera: textos.length - i };
    }
    x.push(cx);
    cx += cw + separacion;
  }
  return { x, fuera: 0 };
}

function cabenTodas(textos: readonly string[], cx: number, limite: number, separacion: number): boolean {
  let x = cx;
  for (const t of textos) {
    x += anchoChip(t);
    if (x > limite) return false;
    x += separacion;
  }
  return true;
}
